import React from "react"
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"
import ButtonGroup from "react-bootstrap/ButtonGroup"
import Row from "react-bootstrap/Row"
import Keywords from "./keywords"

class CV extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            company: 0
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e, i) {
        this.setState({company: i});
    };

    render() {
        return (
            <div className={"my-5"}>
                <ButtonGroup aria-label="CV" className="mb-2">
                    <Row>
                        {this.props.children.map((value, i) => {
                            return (
                                <Button variant="work"
                                        className={this.state.company === i && 'active'}
                                        onClick={(e) => this.handleClick(e, i)}>
                                    {value.props.company}
                                </Button>

                            )
                        })}
                    </Row>
                </ButtonGroup>
                {this.props.children[this.state.company]}
            </div>
        );
    }
}


const Position = props => (
    <div>
        <Card>
            <Card.Body className="card-body">
                <Card.Title>
                    <h5 style={{float: "left", color: "white"}}>{props.charge}
                        <span className={"card-title-color"}> @ {props.company}</span></h5>
                    <h5 style={{float: "right", color: "white"}}>{props.from} - {props.to}</h5>
                    <div style={{clear: "both"}}></div>
                </Card.Title>
                <Card.Text className="text-justify py-3 orange-bullets">{props.children}</Card.Text>
            </Card.Body>
        </Card>
        <Keywords keywords={props.keywords}/>
    </div>
);


export default function Work() {
    return (
        <Container as={"section"} id="work">
            <h3 className={"section-title"} style={{textAlign: `center`}}>Work</h3>

            <div className="separator pt-3">
                <CV>
                    <Position eventKey={"0"} charge={"Computer vision engineer"}
                              from={"10/18"} to={'02/19'} company={"Colorsensing"}
                              keywords={['Classification', 'CNN', 'Keras', 'Sklearn', 'Matplotlib']}>
                        <ul>
                            <li>Design and implementation of a visual water contamination detection system for
                                Bluephage.
                            </li>
                            <li>The system retrieves an image of a Bluephage test bottle and outputs if the water is
                                contaminated and the concentration of viruses present.
                            </li>
                            <li>Various algorithms tested such as Random Forests, Convolutional Networks and Logistic
                                Regression.
                            </li>
                        </ul>
                    </Position>
                    <Position eventKey={"1"} charge={"AI lead"}
                              from={"07/18"} to={'09/18'} company={"Draagu"}
                              keywords={['Image Retrieval', 'Devise', 'ELMO', 'Mobilenetv2', 'Fast.ai', 'Pytorch']}>
                        <ul>
                            <li>Design and implementation of a multimodal Image Retrieval system for mobile devices.
                                Tenfold increase on the number of recognized entities.
                            </li>
                            <li>Design of a remote retrieval system to find the most useful images for training
                                a Deep Neural Network without directly accessing the images for privacy reasons.
                            </li>

                        </ul>
                    </Position>
                    <Position eventKey={"2"} charge={"Research assistant and developer"}
                              from={"01/15"} to={'05/17'} company={" Tecmova"}
                              keywords={['Elder care', 'Anomaly Detection', 'LSTM', 'Keras', 'Tensorflow', 'Fast.ai', 'Pytorch', 'Tensorboard']}>
                        <ul>
                            <li>Design and implementation of an automatic monitoring tool for elderly care based on
                                LSTM.
                            </li>
                            <li>
                                Daily routine learning based on PIR sensor data located around the house.
                            </li>
                            <li>
                                Anomaly detection, fall detection and healthy habits enforcement.
                            </li>
                        </ul>
                    </Position>
                    <Position eventKey={"3"} charge={"Assistant teacher"}
                              from={"06/15"} to={'07/15'} company={"Universitat de Barcelona"}
                              keywords={['Keras', 'Tensorflow', 'Fast.ai', 'Pytorch', 'Tensorboard']}>
                        <ul>
                            <li>Supporting teaching role in the short course ”Deep learning from scratch”.</li>
                            <li>Collaboration in the creation of the course materials.</li>
                            <li>Short lecture about music generation using RNN.</li>
                        </ul>
                    </Position>
                    <Position eventKey={"4"} charge={"Research assistant and developer"}
                              from={"01/15"} to={'12/15'} company={" SEGO"}
                              keywords={['Boostrap 3', 'Django', 'NVD3']}>
                        <ul>
                            <li>Implementation of a web application for data collection and visualization in the field
                                of gynaecological laparoscopy.
                            </li>
                            <li>Currently in use by the Spanish Society of Gynecology and Obstetrics
                                in most of the hospitals in Spain.
                            </li>
                        </ul>
                    </Position>
                    <Position eventKey={"5"} charge={"Junior developer"}
                              from={"10/12"} to={'06/14'} company={"Microstep Spain"}
                              keywords={['Keras', 'Tensorflow', 'Fast.ai', 'Pytorch', 'Tensorboard']}>
                        <ul>
                            <li>Development of a number of applications related to the metal-cutting industry.</li>
                        </ul>
                    </Position>
                </CV>
            </div>
        </Container>
    )
}
